import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';
import { Page } from '@models/*';
import * as overviewStore from '@overviewstore/*';
import { ToastService } from '../core/services/toast.service';

@Injectable()
export class TourStopActionGuard implements CanActivate {
  constructor(
    private toastService: ToastService,
    private store: Store<overviewStore.OverviewState | appStore.AppState>
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(overviewStore.getToursLoaded).pipe(
      filter((isComplete) => isComplete),
      take(1),
      mergeMap(() =>
        zip(this.store.select(overviewStore.getCurrentAction), this.store.select(appStore.getRouterState))
      ),
      take(1),
      map(([action, routerState]) => {
        if (action) {
          return true;
        } else {
          const params = routerState.state.params;
          this.store.dispatch(new appStore.RouterNavigate({ path: [`/tour/${params.tourId}/stop/${params.stopId}`] }));
          this.toastService.generatePageRedirectToast(Page.ACTION);
          return false;
        }
      })
    );
  }
}
